export enum Bank {
  ABNAmro = 'ABN Amro',
  ASN = 'ASN Bank',
  Bunq = 'bunq B.V.',
  Handelsbanken = 'Handelsbanken',
  Ing = 'ING Bank',
  Knab = 'Knab',
  Rabobank = 'Rabobank',
  Regio = 'RegioBank',
  SNS = 'SNS Bank',
  Triodos = 'Triodos Bank',
  VanLanschot = 'Van Lanschot',
  Aktia = 'Aktia',
  Danskebank = 'Danske Bank',
  Nordea = 'Nordea',
  Omasaastopankk = 'Oma Säästöpankk',
  Osuuspankki = 'Osuuspankki',
  Poppankki = 'POP Pankki',
  Spankki = 'S-Pankki',
  Saastopankki = 'Säästöpankki',
  Alandsbanken = 'Ålandsbanken',
  Yoursafe = 'Yoursafe',
  N26 = 'N26 Bank'
}

export const BicCode: Partial<Record<Bank, string>> = {
  [Bank.ABNAmro]: 'ABNANL2A',
  [Bank.ASN]: 'ASNBNL21',
  [Bank.Bunq]: 'BUNQNL2A',
  [Bank.Handelsbanken]: 'HANDNL2A',
  [Bank.Ing]: 'INGBNL2A',
  [Bank.Knab]: 'KNABNL2H',
  [Bank.N26]: 'NTSBDEB1',
  [Bank.Rabobank]: 'RABONL2U',
  [Bank.Regio]: 'RBRBNL21',
  [Bank.SNS]: 'SNSBNL2A',
  [Bank.Triodos]: 'TRIONL2U',
  [Bank.VanLanschot]: 'FVLBNL22',
  [Bank.Yoursafe]: 'BITSNL2A',
}

export const BankId: Partial<Record<Bank, string>> = {
  [Bank.Aktia]: '50',
  [Bank.Danskebank]: '3',
  [Bank.Nordea]: '1',
  [Bank.Handelsbanken]: '6',
  [Bank.Omasaastopankk]: '61',
  [Bank.Osuuspankki]: '2',
  [Bank.Poppankki]: '51',
  [Bank.Spankki]: '10',
  [Bank.Saastopankki]: '52',
  [Bank.Alandsbanken]: '5',
}

export const BankIcon: Record<Bank, string> = {
  [Bank.ABNAmro]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/ABN.svg',
  [Bank.ASN]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/ASN.svg',
  [Bank.Bunq]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Bunq.svg',
  [Bank.Handelsbanken]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Handelsbanker.svg',
  [Bank.Ing]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/ING.svg',
  [Bank.Knab]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Knab.svg',
  [Bank.N26]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/N26.svg',
  [Bank.Rabobank]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Rabobank.svg',
  [Bank.Regio]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Regio.svg',
  [Bank.SNS]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/SNS.svg',
  [Bank.Triodos]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Triodos.svg',
  [Bank.VanLanschot]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/VanLanschot.svg',
  [Bank.Aktia]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Aktia.svg',
  [Bank.Danskebank]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Danske.svg',
  [Bank.Nordea]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Nordea.svg',
  [Bank.Omasaastopankk]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Omadp.svg',
  [Bank.Osuuspankki]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Osuupankki.svg',
  [Bank.Poppankki]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/PopPankki.svg',
  [Bank.Spankki]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Spankki.svg',
  [Bank.Saastopankki]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Saastopankki.svg',
  [Bank.Alandsbanken]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Alandsbanken.svg',
  [Bank.Yoursafe]:
    'https://www.paypalobjects.com/images/checkout/altpayfields/Yoursafe.svg',
}
